var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.groupOperator === 'not')?[_vm._v(" NOT ")]:_vm._e(),(_vm.totalGroups > 1 || _vm.groupOperator === 'not')?[_vm._v("( ")]:_vm._e(),_vm._t("default"),(_vm.totalGroups > 1 || _vm.groupOperator === 'not')?[_vm._v(" )")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }